(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionMultipleChoices', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'E',
            scope: {
                question: '=',
                isDisabled: '=',
                helpText: '&',
                isMultiSelect: '='
            },
            require: ['^form'],
            templateUrl: require('./oddQuestionMultipleChoices.tpl.html'),
            link: function ($scope, $element, $attrs, $ctrl) {
                $scope.form = $ctrl[0];
                $scope.validate();
            },
            controller: ['$rootScope', '$scope', '$timeout', function ($rootScope, $scope, $timeout) {
                $scope.helpText = $scope.helpText();
                $scope.edit = !$scope.question.ODDQuestionChoiceTemplateID;

                $scope.add = add;
                $scope.remove = remove;
                $scope.validate = validate;

                if ($scope.question.ODDQuestionChoiceTemplate && $scope.question.ODDQuestionChoiceTemplate.ODDQuestionChoices) {
                    $scope.question.ODDQuestionChoices = $scope.question.ODDQuestionChoiceTemplate.ODDQuestionChoices;
                }

                function validate() {
                    var isValid = !!($scope.question.ODDQuestionChoices && $scope.question.ODDQuestionChoices.length >= 2);

                    if ($scope.edit) {
                        $scope.form.$setValidity('ODDQuestionChoices', isValid);
                    }
                }

                function add() {
                    if (!$scope.question.ODDQuestionChoices) {
                        $scope.question.ODDQuestionChoices = [];
                    }

                    $scope.question.ODDQuestionChoices.push({});

                    $scope.form.$setDirty();
                    validate();

                    $timeout(function() {
                        $scope.$broadcast('focus.choice.' + ($scope.question.ODDQuestionChoices.length - 1));
                    });
                }

                function remove(index) {
                    $scope.question.ODDQuestionChoices.splice(index, 1);

                    $scope.form.$setDirty();
                    validate();
                }
            }]
        }
    }
})();